import { all, call } from 'redux-saga/effects';

import watchUser from './user/sagas';
import watchSubscriptions from './subscriptions/sagas';
import watchPersonalPlan from './personalPlan/sagas';
import watchNotifications from './notifications/sagas';
import watchGuides from './guides/sagas';
import watchDeepLink from './deepLink/sagas';
import watchBigScreen from './bigScreen/sagas';
import watchAuth from './auth/sagas';
import watchAPI from './api/sagas';
import watchAnalytics from './analytics/sagas';

export default function* rootSaga() {
    yield all([
        call(watchUser),
        call(watchDeepLink),
        call(watchAuth),
        call(watchNotifications),
        call(watchSubscriptions),
        call(watchGuides),
        call(watchPersonalPlan),
        call(watchBigScreen),
        call(watchAPI),
        call(watchAnalytics),
    ]);
}
